import axios from '../axios'

/*
 * 數據模塊
 */
//个人工作量
export const personCount = (data) => {
  return axios({
    url: '/api/count/person',
    method: 'get',
    params: data
  })
};

// 获取团队统计
export const countTeam = (data) => {
	return axios({
		url: '/api/count/team',
		method: 'get',
		params: data
	})
};

// 获取团队详情
export const personTeam = (data) => {
	return axios({
		url: '/api/count/team/stats',
		method: 'get',
		params: data
	})
};

// 获取医院详情
export const countHospitalStats = (data) => {
	return axios({
		url: '/api/count/hospital/stats',
		method: 'get',
		params: data
	})
};

//申请人统计
export const countCreateReport = (data) => {
	return axios({
		url: '/api/count/createReport',
		method: 'get',
		params: data
	})
};

//申请人统计
export const countTotal = (data) => {
	return axios({
		url: '/api/count/total',
		method: 'get',
		params: data
	})
};


// WEBPACK FOOTER //
// ./src/http/moudules/count.js